<template>
  <div id="34_main">
    <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
    <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    <div>
      <v-data-table
        dense
       :headers="tableHeadCreate"
       :items="tableList"
       :items-per-page="15"
      >
        <template v-slot:top>

          <v-dialog v-model="dialog" max-width="900px">
           
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-treeview 
              :items="itemsTree"
              :load-children="getTreeChild"
              v-model="selectionTree"
              selectable
              selected-color="red"
              
              open-on-click
              transition
              >
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="item.children">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                </template>
              </v-treeview>
  
              <v-card-text v-if="editedIndex !== -1">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" v-for="sklad in editItems" v-bind:key="sklad.idsklad">
                    <v-text-field  
                      v-bind:label="sklad.namesklad" 
                      v-bind:value="sklad.countsklad" 
                      v-on:input="sklad.countsklad = $event"
                    >
                    </v-text-field>
                    </v-col>
                   
                  </v-row>
                </v-container>
              </v-card-text>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-toolbar flat color="white">
            <v-toolbar-title>Контроль залишків на складах</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="newItem">Додати</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        dialog: false,
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        headers: [
          { text: '', value: 'actions', sortable: false },
          { text: 'ТМЦ', value: 'name', align: 'start', sortable: true},
        ],
        sklads: [],
        tableList: [],
        editedIndex: -1,
        editName: '',
        editItems: [],
        selectionTree: [],
        itemsTree: [],
      }
    },
    computed: {
      tableHeadCreate: function () {
        return this.headers.concat(this.sklads)
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Додати ТМЦ для контролю' : this.editName
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    methods: {
      getTableData () {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '34',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.sklads = data.sklads;
            this.tableList = data.tablelist;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
        });
      },
      getTree(tab) {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '9999',
            ww: '3',
            pp: localStorage.pp,
            pn: localStorage.pn,
            tab: tab,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
          .then(async response => {
            const data = await response.json();
            if (!response.ok) {
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }
            this.itemsTree = data;
            this.progresLineShow = false;
          })
          .catch(error => {
            this.errorMessage = error;
            this.progresLineShow = false;
            this.errorAlertShow = true;
          });

      },
      async getTreeChild(item) {
        const requestOptions = await {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '9999',
            ww: '3',
            pp: localStorage.pp,
            pn: localStorage.pn,
            tab: item.id,
          })
        }
        return fetch(this.$store.getters.apiUrl, requestOptions)
          .then(res => res.json())
          .then(json => (item.children.push(...json)))
          .catch(err => console.warn(err))
      },
      newItem () {
        this.dialog = true
        this.getTree(0)
      },
      editItem (item) {
        this.editName = item.name
        this.editedIndex = item.tmcid
        for (var keyItem in item) {
          for (var kaySklad in this.sklads) {
            var thisSklad = this.sklads[kaySklad]
            if (thisSklad.value === keyItem) {
              var skladValueItem = {
                idsklad: thisSklad.value,
                namesklad: thisSklad.text,
                countsklad: item[keyItem]
              }
              this.editItems.push(skladValueItem)
            }
            
          }
        }
        this.dialog = true
      },
      deleteItem (item) {
        if ( confirm('Видалити?') ) {
          this.progresLineShow = true;
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              act: '34',
              ww: '3',
              pp: localStorage.pp,
              pn: localStorage.pn,
              tmcid: item.tmcid,
            })
          };
          fetch(this.$store.getters.apiUrl, requestOptions)
            .then(async response => {
              const data = await response.json();
              if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error)
              }
              this.getTableData()
              this.progresLineShow = false
            })
            .catch(error => {
              this.errorMessage = error
              this.progresLineShow = false
              this.errorAlertShow = true
            });
        }
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editName = ''
          this.editedIndex = -1
          this.editItems = []
          this.selectionTree =  []
          this.itemsTree = []
        })
      },
      save () {
        if (this.editedIndex === -1 && this.selectionTree.length > 0) {
          this.progresLineShow = true;
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              act: '34',
              ww: '2',
              pp: localStorage.pp,
              pn: localStorage.pn,
              items: this.selectionTree,
            })
          };
          fetch(this.$store.getters.apiUrl, requestOptions)
            .then(async response => {
              const data = await response.json();
              if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error)
              }
              this.getTableData()
              this.progresLineShow = false
            })
            .catch(error => {
              this.errorMessage = error
              this.progresLineShow = false
              this.errorAlertShow = true
            });
        } 
        if (this.editedIndex > 0) {
          this.progresLineShow = true;
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              act: '34',
              ww: '4',
              pp: localStorage.pp,
              pn: localStorage.pn,
              tmcid: this.editedIndex,
              editItems: this.editItems,
            })
          };
          fetch(this.$store.getters.apiUrl, requestOptions)
            .then(async response => {
              const data = await response.json();
              if (!response.ok) {
                const error = (data && data.message) || response.status;
                return Promise.reject(error)
              }
              this.getTableData()
              this.progresLineShow = false
            })
            .catch(error => {
              this.errorMessage = error
              this.progresLineShow = false
              this.errorAlertShow = true
            });
        }
        this.close()
      },
    },
    created: function () {
      this.getTableData()
    },
  }
</script>